<template>
  <div>
    <div class="box" :style="{'min-width': '1000px'}">
      <div ref="head">
        <hdHead
          :cTitle="plive.lName"
          :cEnd="plive.lEndDt"
          :cIcon="plive.lBackUrl"
          :cStart="plive.lStartDt"></hdHead>
      </div>
      <div style="text-align: center;position: relative;margin-top: 30px;">
        <p class="page-title">实时互动</p>
      </div>
      <div class="content-box" style="margin-bottom: 60px;">
        <!--        <ul>
                  <li v-if="item.top" :class="[item.top? 'active-item': '']" v-for="(item,i) in listData" :key="i" class="clear">
                    <div class="left" style="width: 90%">
                      <h1 class="clear">
                        <span class="left">{{item.ctName}}</span>
                        <span style="font-size: 12px;color: #000000;margin-top: 2px;" class="right">{{item.ctDate}}</span>
                      </h1>
                      <p style="word-wrap: break-word;">{{item.ctContent}}</p>
                    </div>
                    <div @click="setTop(i,item)" class="right btn">
                      <span v-if="item.top">取消</span>
                      <span v-if="!item.top">置顶</span>
                    </div>
                  </li>
                </ul>-->
        <ul :style="{'height': `${contentHeight-20}px`,'overflow-y':'scroll'}" id="scroll-box-hd">
          <transition-group name="list-complete">
            <li @click="showItemCon(item,i)"
                :class="[item.top? 'active-item': '',activeIndex===i?'active-c':'',i%2===0?'jiange':0]"
                v-for="(item,i) in listData" :key="i" class="clear list-complete-item">
              <div class="left" style="width: 100%">
                <h1 class="clear">
                  <!--ctMtype ===1 管理员-->
                  <span :class="[item.ctMtype === '1' ? 'guanliyuan': '']" class="left">{{item.ctName}}</span>
                  <span style="font-size: 12px;color: #000000;margin-top: 2px;" class="right">{{item.ctDate | formatDate}}</span>
                </h1>
                <p style="word-wrap: break-word;margin-top: 5px;margin-bottom: 3px;">{{item.ctContent}}</p>
              </div>
              <!--<div @click="setTop(i,item)" class="right btn">
                <span v-if="item.top">取消</span>
                <span v-if="!item.top">置顶</span>
              </div>-->
            </li>
          </transition-group>
        </ul>
        <div class="xs xs1"></div>
        <div class="xs xs2"></div>
        <div class="xs xs3"></div>
        <div class="xs xs4"></div>
        <div class="xs xs5"></div>
        <div class="xs xs6"></div>
        <div class="xs xs7"></div>
        <div class="xs xs8"></div>
        <div class="xs xs9"></div>
        <div v-show="!scrollToBottomFlag && newNum>0" class="new-nums">
          <span @click="moveToBottom(true,'Quint.easeOut')">{{newNum}}条新消息</span>
        </div>
      </div>
    </div>
    <transition name="fade">
      <div @click="showCurrContent=false" v-if="showCurrContent" class="cover"></div>
    </transition>
    <transition name="slide-fade">
      <div v-if="showCurrContent" class="fix-box">
        <b class="bar bar1"></b>
        <b class="bar bar2"></b>
        <div class="bar-2">
          <i class="bar-1"></i>
        </div>
        <div class="bar-22">
          <i class="bar-1"></i>
        </div>
        <div class="fix-box2" :class="[showCurrContent?'active':'']">
          <h1 class="fix-box-title">{{currentContent.ctName}}</h1>
          <p class="fix-box-time">{{currentContent.ctDate | formatDate}}</p>
          <img class="fix-box-logo" style="width: 100px;" src="./logo.png" alt="">
          <div class="content-tip"></div>
          <div class="fix-box-content">
            {{currentContent.ctContent}}
          </div>
          <div class="fix-box-bottom"></div>
        </div>
        <div class="fix-box-close" @click="showCurrContent=false"></div>
      </div>
    </transition>
    <div ref="footer-box" class="footer1">
      <img src="./bottom_logo.png" alt="">
    </div>
  </div>
</template>
<script>
  import hdHead from '../hdHead'
  import GLOBAL from '@/common/global'
  export default{
    data(){
      return {
        scrollToBottomFlag: true, //是否可以滚动到底部，当用户操作后，不可以滚动
        beginHeight: 0,
        plive: {},
        systime: 0,
        liveId: 0,
        contentHeight: 0, // content 高度
        listData: [],
        showCurrContent: false,//是否显示弹框 默认不显示
        currentContent: '',
        activeIndex: '',
        timer: '' //定时器指针，轮询接口指针
      }
    },
    filters: {
      formatDate(time){
        let formatStr = new Date(time).Format('yyyy-MM-dd hh:mm');
        return formatStr;
      }
    },
    components: {
      hdHead
    },
    props: {},
    methods: {
      showItemCon(item, i){
        this.scrollToBottomFlag = false;
        this.showCurrContent = true;
        this.currentContent = item;
        this.activeIndex = i;
      },
      resizeWindow(){
        window.addEventListener('resize', () => {
          this.beginHeight = document.documentElement.clientHeight - 55;
          let contentHeight = document.documentElement.clientHeight - this.$refs['footer-box'].offsetHeight - this.$refs.head.offsetHeight - 134;
          this.contentHeight = contentHeight;
        })
      },
      setTop(i, item){
        let top = item.top;
        if (top === 1) {
//                  取消置顶
          item.top = 0;
        } else {
//                  置顶
          item.top = 1;
          item.dateTime = new Date().getTime();
        }
        this.$set(this.listData, i, item);
      },
      toPosition(_obj){
      },
      /**
       *监听没有看到过的消息个数
       */
      watchNewNums(){
        let scrollBox = document.getElementById('scroll-box-hd');
        let lis = scrollBox.querySelectorAll('li');
        let scrollTop = scrollBox.scrollTop;
        lis.forEach((item, i) => {
          let selfTop = item.offsetTop;
//                console.log(selfTop);
          if (selfTop - scrollTop < this.contentHeight - 60) {
            this.listData[i].isNew = false;
          }
        })
      },
      listenermouseWheel(){
        let that = this;
        let scrollFunc = function () {
          that.scrollToBottomFlag = false;
          let scrollBox = document.getElementById('scroll-box-hd');
          let scrollHeight = scrollBox.scrollHeight;
          let currScrollTop = scrollBox.scrollTop;
//                if(scrollHeight)
//                console.log(scrollHeight-currScrollTop);
          if (scrollHeight - currScrollTop == scrollBox.offsetHeight) {
            that.scrollToBottomFlag = true;
            that.listData.map((item, i) => {
              item.isNew = false;
              that.$set(that.listData,i,item);
            });
          }
        };
        //给页面绑定滑轮滚动事件
        if (document.addEventListener) {
          document.addEventListener('DOMMouseScroll', scrollFunc, false);
        }
        //滚动滑轮触发scrollFunc方法
        window.onmousewheel = document.onmousewheel = scrollFunc;
      },
      moveToBottom(flag, easing){
        let scrollBox = document.getElementById('scroll-box-hd');
        let scrollHeight = scrollBox.scrollHeight;
        let currScrollTop = scrollBox.scrollTop;
        if (this.scrollToBottomFlag === false && !flag) {
          return;
        }
        easing = easing || 'Linear';
        Math.animation(currScrollTop, scrollHeight, 1000, easing, (value, end) => {
          if (end) {
            this.listData.map((item, i) => {
              item.isNew = false;
              this.$set(this.listData,i,item);
            });
            console.log(this.listData);
            this.scrollToBottomFlag = true;
          }
          scrollBox.scrollTop = value;
        });
      },
      /**
       * socket 长链接 获取新数据
       */
      getData(){
//        生产环境
//        let socket = io.connect('//101.200.234.55:3001/');
        // let socket = io.connect('//101.200.234.55:3002/');

       let socket = io.connect(GLOBAL.SOCKETPORT);
        let param = {
          userid: Math.random().toString(16),
          roomid: this.liveId,
          username: Math.random().toString(16)
        };
        socket.on('connect', () => {
            console.log('链接成功');
          socket.emit('login', param);
        });
        socket.on('upwaller', (data) => {
            console.log('wall',data);
          data.dateTime = new Date().getTime();
          data.top = 0;
          data.isNew = true;
          this.listData.push(data);
          setTimeout(() => {
            this.moveToBottom();
          }, 27);
          this.watchNewNums();
        });
        socket.on('disconnect',()=>{
            console.log('断开了连接');
          socket = io.connect(GLOBAL.SOCKETPORT);
        })
      }
    },
    computed: {
      newNum(){
        let num = 0;
        this.listData.map((item, i) => {
          if (item.isNew) {
            num++;
          }
        });
        return num;
      },
      topData(){
        let tempArr = [];
        let cloneArr = [];
//              先将聊天信息按照时间戳大小排序
        function sortNumber(item1, item2) {
//          console.log(item1.dateTime - item2.dateTime);
          return item1.dateTime - item2.dateTime;
        }

        cloneArr = this.listData.map((item, i) => {
          return item;
        });
        let sortArr = cloneArr.sort(sortNumber);

        sortArr.map((item, i) => {
          if (item.top === 1) {
            tempArr.push(item);
          }
        });
        return tempArr;
      }
    },
    mounted(){
      document.title = "直播互动";
      this.beginHeight = document.documentElement.clientHeight - 75;
      let contentHeight = document.documentElement.clientHeight - this.$refs['footer-box'].offsetHeight - this.$refs.head.offsetHeight - 134;
      this.contentHeight = contentHeight;
      let liveId = this.$route.params.liveId;
      this.liveId = liveId;
      let cid = this.$route.params.cid;
      this.resizeWindow();
      this.listenermouseWheel();
      axios.request({
        url: '/medapp/api/manage/live/getallowchat',
        method: 'post',
        data: {
          liveid: liveId
        }
      }).then((res) => {
        console.log(res);
        this.systime = res.data.systime;
        this.listData = res.data.chat;
        this.listData.map((item, i) => {
          item.dateTime = new Date().getTime();
          item.top = 0;
          item.isNew = true;
        });
//              每隔10秒轮询一次后台，获得数据
//        this.timer = setInterval(, 5000);
        this.getData();
      }).catch((err) => {
        console.log(err);
      });

//          获取会议信息，名字，icon图片，时间等信息
      axios.request({
        url: '/medapp/api/con/live/roomlist',
        method: 'post',
        data: {
          cid: cid
        }
      }).then((res) => {
//        console.log(res);
        this.plive = res.data.plive;
      })
    },
    watch: {
      $route (to, from) {
        console.log('路由变化了')
      }
    }
  }
</script>
<style scoped>
  .left {
    float: left;
  }

  .right {
    float: right;
  }

  .clear:after {
    content: '';
    display: block;
    clear: both;
  }

  .box {
    /*width: 1018px;*/
    padding: 0 150px;
    margin: 0 auto;
    font-size: 16px;
    color: #000000;
  }

  .footer1 {
    width: 100%;
    background-color: #E5E5E5;
    padding: 10px 0;
    text-align: center;
  }

  .content-box {
    border: 1px solid #C9C9C9;
    position: relative;
  }

  .content-box li {
    padding: 0 12px;
    border-bottom: 1px solid #C9C9C9;
    position: relative;
  }

  /*.content-box li:hover{*/
  /*!*background-color: #efefef;*!*/
  /*}*/
  .content-box li.active-item {
    background-color: #e5e4e4;
  }

  .content-box li h1 {
    font-size: 16px;
    margin-top: 6px;
    color: #F39B07;
  }

  .content-box li p {
    font-size: 14px;
    color: #000;
    /*margin-top: 10px;*/
    margin-bottom: 5px;
  }

  .btn {
    padding: 3px 10px;
    color: #F39800;
    border-radius: 5px;
    border: 1px solid #F39800;
    font-size: 14px;
    position: absolute;
    right: 20px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }

  .btn:hover {
    color: red;
    border-color: red;
  }

  .page-title {
    color: red;
    font-size: 20px;
    font-weight: bold;
    display: inline-block;
    position: relative;
    margin-bottom: 30px;
  }

  .page-title:before {
    content: '';
    display: block;
    position: absolute;
    width: 370px;
    left: -390px;
    height: 100%;
    top: 0;
    background: url("./line.png") no-repeat left center/contain;
  }

  .page-title:after {
    content: '';
    display: block;
    position: absolute;
    width: 370px;
    right: -390px;
    height: 100%;
    top: 0;
    background: url("./line2.png") no-repeat left center/contain;
  }

  .content-box .xs {
    border: 0;
    position: absolute;
  }

  .xs1 {
    width: 138px;
    height: 38px;
    left: -5px;
    top: -38px;
    background: url("./xs1.png") no-repeat right bottom/contain;
  }

  .xs2 {
    width: 138px;
    height: 38px;
    right: -4px;
    top: -38px;
    background: url("./xs2.png") no-repeat right bottom/contain;
  }

  .xs3 {
    width: 38px;
    height: 138px;
    right: -38px;
    top: -3px;
    background: url("./xs3.png") no-repeat left center/contain;
  }

  .xs4 {
    width: 38px;
    height: 138px;
    right: -38px;
    bottom: -4px;
    background: url("./xs4.png") no-repeat left center/contain;
  }

  .xs6 {
    width: 138px;
    height: 38px;
    right: -4px;
    bottom: -38px;
    background: url("./xs6.png") no-repeat right top/contain;

  }

  .xs7 {
    width: 138px;
    height: 38px;
    left: -5px;
    bottom: -38px;
    background: url("./xs7.png") no-repeat left top/contain;
  }

  .xs8 {
    width: 38px;
    height: 138px;
    left: -38px;
    bottom: -4px;
    background: url("./xs8.png") no-repeat right center/contain;
  }

  .xs9 {
    width: 38px;
    height: 138px;
    left: -38px;
    top: -2px;
    background: url("./xs9.png") no-repeat right center/contain;
  }

  .list-complete-item {
    transition: all 1s;
  }

  .list-complete-enter, .list-complete-leave-active {
    opacity: 0;
  }

  .list-complete-leave-active {
    position: absolute;
  }

  .new-nums {
    text-align: center;
    width: 100%;
    position: absolute;
    bottom: -50px;
  }

  .new-nums span {
    display: inline-block;
    padding: 10px 15px;
    background-color: #00c261;
    color: #ffffff;
    font-size: 14px;
    border-radius: 20px;
    cursor: pointer;
  }

  .cover {
    position: fixed;
    left: 0;
    top: 0;
    bottom: 0;
    right: 0;
    z-index: 8;
    background-color: rgba(0, 0, 0, .7);
  }

  .fix-box {
    border-radius: 30px;
    position: absolute;
    z-index: 10;
    left: 20%;
    top: 50%;
    transform: translateY(-50%);
    right: 20%;
    overflow: hidden;
    perspective: 1200px;
  }

  .bar-box {
    position: absolute;
    width: 100%;
    z-index: 20;
  }

  .bar {
    background-color: #ffffff;
    height: 55px;
    width: 30px;
    position: absolute;
    border-radius: 30px;
    z-index: 22;
  }

  .bar-1 {
    position: absolute;
    width: 36px;
    height: 55px;
    background-color: #009E96;
    left: 3px;
    bottom: 0;
    margin-left: -3px;
    border-radius: 30px;
    z-index: 21;
    margin-top: 3px;
  }

  .bar-2 {
    position: absolute;
    width: 36px;
    height: 28px;
    left: 20%;
    overflow: hidden;
    margin-top: 30px;
    margin-left: -3px;
  }

  .bar-22 {
    position: absolute;
    width: 36px;
    height: 28px;
    right: 20%;
    overflow: hidden;
    margin-top: 30px;
    margin-right: -3px;
  }

  .bar-22 .bar-1 {

  }

  .bar1 {
    left: 20%;
  }

  .bar2 {
    right: 20%;
  }

  .fix-box-title {
    color: #F39800;
    margin-left: 30px;
    margin-top: 30px;
    font-size: 35px;
  }

  .fix-box-time {
    margin-left: 30px;
    color: #000000;
  }

  .fix-box-logo {
    position: absolute;
    right: 60px;
    top: 60px;
  }

  .content-tip {
    height: 130px;
    background: url("./yun.png") center center/cover;
  }

  .fix-box-content {
    min-height: 196px;
    font-size: 20px;
    background-color: #009E96;
    color: #ffffff;
    box-sizing: border-box;
    padding: 30px;
    word-wrap: break-word;
  }

  .fix-box-bottom {
    background: #009E96 url("./bottom.png") repeat left top;
    width: 100%;
    height: 32px;
  }

  .fix-box2 {
    margin: 30px;
    border-radius: 30px;
    overflow: hidden;
    background-color: #fff;
    transform: rotateX(90deg);
    transform-style: perserve-3d;
  }

  .fix-box2.active {
    animation: fix2 ease-in-out 2s;
    transform-origin: center 0;
    animation-delay: .1s;
    animation-fill-mode: forwards;
  }

  @keyframes fix2 {
    0% {
      transform: rotateX(110deg);
    }
    50% {
      transform: rotateX(-15deg);
    }
    100% {
      transform: rotateX(0deg);
    }
  }

  .fix-box-close {
    width: 40px;
    height: 40px;
    position: absolute;
    right: 15px;
    top: 15px;
    cursor: pointer;
    background: url("./cancel.png") no-repeat center center/contain;
  }

  .slide-fade-enter-active, .slide-fade-leave-active {
    transition: all .3s ease;
  }

  .slide-fade-enter, .slide-fade-leave-active {
    top: -100%;
    opacity: 0;
  }

  .fade-enter-active, .fade-leave-active {
    transition: all .3s ease;
  }

  .fade-enter, .fade-leave-active {
    opacity: 0;
  }

  .jiange {
    background-color: #F8F6F6;
  }

  .active-c {
    background-color: #eeeeee;
  }

  .guanliyuan {
    /* color: red; */
  }
</style>



// WEBPACK FOOTER //
// hdList.vue?6c2d453e